import React from 'react'
import Typist from 'react-typist'
import "./css/landing-content.css"
import MobileDoctor from "../images/mobile-doc.png"
import LaptopDoctor from "../images/Laptop-Doc.png"

const handleScroll = () => {
  console.log("We've been scrolled")
}

const LandingContent = () => {
  return (
    <div onScroll={handleScroll} className='display-flex' id="main-content">
      <div className='display-flex' id='textual-content'>
        <div className='display-flex' id="main-text">
          <Typist 
            avgTypingDelay={80} 
            startDelay={1000}
            cursor={{ hideWhenDone: true }}
          >
            
            <span id="prim" className="heavier">
              We offer standard 
               <Typist.Backspace count={8} delay={500}/>
              <Typist.Delay ms={500}/>
              quality
              <Typist.Backspace count={7} delay={500}/>
              <Typist.Delay ms={500}/>
              the best
            </span><br />
            <Typist.Delay ms={500} />
            <span id="hmo-services" className="normal"> HMO services.  </span>
          </Typist>
        </div>
        <div className="display-flex" id="sec-text">
          <span id="sec">
          Get Affordable Health Insurance For Individuals, Families, and Companies From The Best HMO in Nigeria.
          </span>
        </div>
        <button className='button-shake' id='learn-more'>
          LEARN MORE
        </button>
      </div>
      <div className="display-flex" id="doc-pic-container">
        <img id="doctor" src={MobileDoctor} alt="doc"></img>
        <img id="laptop-doctor" src={LaptopDoctor} alt="doc"></img>
      </div>
    </div>
  )
}

export default LandingContent;